import React from 'react'
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginTile from './LoginTile';
import Cookies from 'js-cookie';


function NewCommentTile({ collectionGroupId, documentId, parentId, commentEntry, idx }) {
    const navigate = useNavigate();

    const getUserName = () => {
        const user = Cookies.get('username');
        if (user) {
            return user;
        } else {
            return '';
        }
    }

    const [addingNewComment, setAddingNewComment] = useState(false);
    const [addedCommentText, setAddedCommentText] = useState("");
    const [addedCommentEditable, setAddedCommentEditable] = useState(false);
    const [allowNewComment, setAllowNewComment] = useState(true);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [showLoginWindow, setShowLoginWindow] = useState(false);

    const handleLoginTileReturn = (sts) => {
        setShowLoginWindow(false);
    }
    const formatDate = (d) => {
        return d.toLocaleDateString();
    }
    const [addedCommentRecord, setAddedCommentRecord] = useState({
        id: null,
        created: null,
        documentId: documentId,
        collectionGroupId: collectionGroupId,
        parent: null,
    });

    const handleAddingNewComment = () => {
        if (getUserName()) {
            setAddingNewComment(true);
            setAddedCommentEditable(true);
        } else {
            setShowErrorMessage(true);
        }
    }
    const deleteComment = async (commentId, baseOrReply) => {
        axios
            .delete("/api/v1/comments/" + commentId)
            .then((result) => { })
            .catch((err) => console.log(err));

    }

    const saveAddedComment = async () => {
        let tmpComment = addedCommentRecord;
        tmpComment.comment = addedCommentText;
        axios
            .post("/api/v1/comments", tmpComment)
            .then(function (response) {
                if (response.status === 200) {
                    setAddedCommentRecord(response.data);
                }
            })
            .catch((err) => console.log(err));
    }
    const handleSaveAddedComment = (e) => {
        saveAddedComment();
        setAddedCommentEditable(false);
    }
    const handleAddedCommentCancel = (e) => {
        setAddedCommentEditable(false);
        setAddingNewComment(false);
        setAddedCommentRecord();
        setAddedCommentText("");

    }
    const handleAddedCommentDelete = (e) => {
        deleteComment(addedCommentRecord.id);
        setAddedCommentRecord
            ({
                id: null,
                created: null,
                collectionGroupId: collectionGroupId,
                documentId: documentId,
                parent: null,
            });
        setAddingNewComment(false);
    }


    return (
        <div>
            <div style={{ display: idx === 0 ? "block" : "none" }}>
                <input style={{ display: allowNewComment ? "block" : "none" }} type="button" value="New Comment" onClick={handleAddingNewComment} />
                <div style={{ paddingLeft: "50", display: addingNewComment ? "block" : "none" }}>
                    <div className="commentContainer" >

                        <span style={{ marginBottom: "10px" }}>
                            On {formatDate(new Date())}, {getUserName()} said:
                            <hr />
                        </span>
                        {addedCommentEditable ?
                            <div>
                                <div className="commentInputContainer">
                                    <textarea
                                        rows="5"
                                        className="commentInputContainer__input"
                                        autoFocus
                                        onChange={(e) => setAddedCommentText(e.target.value)}
                                        value={addedCommentText}
                                    />
                                </div>
                                <div>
                                    <hr />
                                    <span className="commentReply" onClick={handleSaveAddedComment}>Save</span>
                                    <span className="commentReply" onClick={handleAddedCommentCancel}>Cancel</span>
                                </div>
                            </div>
                            :
                            <div>
                                <div>
                                    <div>
                                        <div>
                                            <span style={{ wordWrap: "break-word" }}>
                                                {addedCommentText}
                                            </span>
                                            <div>
                                                <hr />
                                                <span className="commentReply" onClick={handleAddedCommentDelete}>Delete</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {showErrorMessage && (
                <div className="overlay">
                    <div className="popup">
                        <h3>Error</h3>
                        <p>Only registered users can contribute to the debate.</p>
                        <div className="header-link">
                            <div onClick={() => navigate("/Register.html")}>Register</div>
                            <div onClick={() => { setShowErrorMessage(false); setShowLoginWindow(true) }}>Login</div>
                            <button onClick={() => setShowErrorMessage(false)}>Ok</button>
                        </div>
                    </div>
                </div>
            )}
            {showLoginWindow && (
                <LoginTile sendValueBack={handleLoginTileReturn} />
            )}
        </div >
    )
}

export default NewCommentTile
